var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-section',{attrs:{"spacing":false}},[_c('TaskList',{attrs:{"qso":{ append: ("&operator=" + _vm.id), prepend: '?' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }